<script setup>
import { useSetting } from '@/composables/useSetting'

// pages/administration/settings/index.vue — Module 21 (§7 `2.0.4`). Tab
// SMTP/AI Provider/Update Channel/Umum — dua tab pertama pakai komponen
// tersendiri (SmtpForm.vue/AiProviderForm.vue, per literal blueprint), dua
// tab terakhir cukup sederhana untuk inline di halaman ini tanpa komponen
// terpisah (blueprint tidak menamai komponen untuk keduanya).
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'Setting',
  },
})

const { settings, loading, saving, fetchSettings, updateSettings } = useSetting()

const tab = ref('smtp')
const updateForm = ref({ channel: 'stable', check_interval_hours: 24 })
const generalForm = ref({ facility_name: '' })
const otherResult = ref(null)

onMounted(async () => {
  await fetchSettings()
  updateForm.value = { ...settings.value.update }
  generalForm.value = { ...settings.value.general }
})

const channelOptions = [
  { title: 'Stable', value: 'stable' },
  { title: 'Beta', value: 'beta' },
]

const saveUpdateChannel = async () => {
  otherResult.value = null
  await updateSettings({ update: updateForm.value })
  otherResult.value = { type: 'success', message: 'Pengaturan Update Channel tersimpan.' }
}

const saveGeneral = async () => {
  otherResult.value = null
  await updateSettings({ general: generalForm.value })
  otherResult.value = { type: 'success', message: 'Pengaturan Umum tersimpan.' }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Pengaturan
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Konfigurasi integrasi terpusat — tidak ada kredensial hardcode (§34)
    </p>

    <VProgressLinear
      v-if="loading"
      indeterminate
      color="primary"
      class="mb-4"
    />

    <VCard v-else>
      <VTabs v-model="tab">
        <VTab value="smtp">
          SMTP
        </VTab>
        <VTab value="ai">
          AI Provider
        </VTab>
        <VTab value="update">
          Update Channel
        </VTab>
        <VTab value="general">
          Umum
        </VTab>
      </VTabs>

      <VDivider />

      <VWindow v-model="tab">
        <VWindowItem value="smtp">
          <VCardText class="pa-6">
            <SmtpForm :model-value="settings.smtp" />
          </VCardText>
        </VWindowItem>

        <VWindowItem value="ai">
          <VCardText class="pa-6">
            <AiProviderForm :model-value="settings.ai" />
          </VCardText>
        </VWindowItem>

        <VWindowItem value="update">
          <VCardText class="pa-6">
            <VAlert
              v-if="otherResult"
              :type="otherResult.type"
              variant="tonal"
              class="mb-4"
              closable
              @click:close="otherResult = null"
            >
              {{ otherResult.message }}
            </VAlert>
            <VRow>
              <VCol
                cols="12"
                md="6"
              >
                <VSelect
                  v-model="updateForm.channel"
                  :items="channelOptions"
                  label="Channel Update"
                />
              </VCol>
              <VCol
                cols="12"
                md="6"
              >
                <VTextField
                  v-model="updateForm.check_interval_hours"
                  type="number"
                  label="Interval Cek Update (jam)"
                />
              </VCol>
            </VRow>
            <VBtn
              color="primary"
              :loading="saving"
              @click="saveUpdateChannel"
            >
              Simpan
            </VBtn>
          </VCardText>
        </VWindowItem>

        <VWindowItem value="general">
          <VCardText class="pa-6">
            <VAlert
              v-if="otherResult"
              :type="otherResult.type"
              variant="tonal"
              class="mb-4"
              closable
              @click:close="otherResult = null"
            >
              {{ otherResult.message }}
            </VAlert>
            <VRow>
              <VCol cols="12">
                <VTextField
                  v-model="generalForm.facility_name"
                  label="Nama Fasilitas Kesehatan"
                />
              </VCol>
            </VRow>
            <VBtn
              color="primary"
              :loading="saving"
              @click="saveGeneral"
            >
              Simpan
            </VBtn>
          </VCardText>
        </VWindowItem>
      </VWindow>
    </VCard>
  </div>
</template>
